import { render, staticRenderFns } from "./TopLanguageSwitch.vue?vue&type=template&id=94e7b4a4&scoped=true&"
import script from "./TopLanguageSwitch.vue?vue&type=script&lang=js&"
export * from "./TopLanguageSwitch.vue?vue&type=script&lang=js&"
import style0 from "./TopLanguageSwitch.vue?vue&type=style&index=0&id=94e7b4a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e7b4a4",
  null
  
)

export default component.exports